import { QueryClient } from "@tanstack/react-query";

const QUERY_STALE_TIME_MS = 5 * 60 * 1000;
const QUERY_RETRIES = 1;

export const createQueryClient = () => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: QUERY_STALE_TIME_MS,
        retry: QUERY_RETRIES,
      },
    },
  });
};
